import { omit } from 'ramda';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

export const initialState = {
	sort: '',
	policies: [],
	sellerNumbers: [],
	searchedCriterias: null,
	focusField: null,
};

const reducerMap = {
	[types.SET_SORT]: (state, { payload }) => {
		return {
			...state,
			sort: payload.sort,
		};
	},
	[types.SET_POLICIES]: (state, { payload }) => {
		return {
			...state,
			policies: payload.policies,
		};
	},
	[types.SET_SELLER_NUMBERS]: (state, { payload }) => {
		return {
			...state,
			sellerNumbers: payload.sellerNumbers,
		};
	},
	[types.APPEND_POLICIES]: (state, { payload }) => {
		return {
			...state,
			policies: state.policies.concat(payload.policies),
		};
	},
	[types.SAVE_SEARCHED_CRITERIAS]: (state, { payload }) => {
		return {
			...state,
			searchedCriterias: payload.searchedCriterias,
		};
	},
	[types.SAVE_FOCUS_FIELD]: (state, { payload }) => {
		return {
			...state,
			focusField: payload.key,
		};
	},
	[types.REMOVE_FILTER_CRITERIA_BY_KEY]: (state, { payload }) => {
		return {
			...state,
			searchedCriterias: omit([payload.key], state.searchedCriterias),
		};
	},
	[types.RESET_WITHOUT_SELLER_NUMBERS]: (state) => {
		return {
			...state,
			policies: initialState.policies,
			sort: initialState.sort,
			searchedCriterias: initialState.searchedCriterias,
		};
	},
	[types.RESET_WITHOUT_SELLER_NUMBERS_AND_SEARCHED_CRITERIAS]: (state) => {
		return {
			...state,
			policies: initialState.policies,
			sort: initialState.sort,
		};
	},
	[types.RESET]: () => initialState,
};

export default handleActions(reducerMap, initialState);
